window.quicksingleorderform = window.quicksingleorderform || {};

quicksingleorderform.init = function() {
quicksingleorderform.multiAddToCart.init(); // Multiple Add To cart
  
if(!qformjQ("#orderformpage").length){   
return;
}
  
var coll_handle = qformjQ("#choose_coll option:selected").val();
var pg_no = 1;
var ajax_url = '/collections/'+coll_handle+'?page='+pg_no+'&view=get-orderitems';
  
qformjQ('#orderform_search #search_ord_item_term').attr('class','orderitem-search_box');
  
// Due to CSS Conflict with modal
qformjQ(".page-container").removeClass("page-container");
qformjQ(".page-container").removeClass('is-moved-by-drawer');  

function print_html(response)
{
    	if(/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
    		var input_type = 'number';  
   		} else {                       
    		var input_type = 'text';
        }
  
   	    //If there are no items in collection then hide multiaddtocart bttn
        if(response.total_items==0) {
          qformjQ(".multiaddtocart").css("display","none");
          qformjQ("table#order_items").hide();
          qformjQ("#order_noresult").show();
        } else {
          qformjQ("table#order_items").show();
          qformjQ("#order_noresult").hide();
          qformjQ(".multiaddtocart").css("display","block");
        }
        
        if(response.total_pages > 1 && response.total_items > window.products_limit) {
        qformjQ(".orderitems_paging").html('<button class="prev_paging" type="button" title="Previous">&lt;&lt;</button><span class="current_page" data-currpage="'+response.current_page+'">'+response.current_page+'</span><button title="Next" class="next_paging" type="button">&gt;&gt;</button>');
        
        if(response.current_page > 1) {
          qformjQ(".prev_paging").prop("disabled", false);
        } else {
          qformjQ(".prev_paging").prop("disabled", true);
        }
        
        if(response.current_page != response.total_pages) {
          qformjQ(".next_paging").prop("disabled", false);
        } else {
          qformjQ(".next_paging").prop("disabled", true);
        }
        
        } else {
        qformjQ(".orderitems_paging").empty();
        }
        
        qformjQ('#item_results').empty();
        qformjQ('.discription_div').empty();
    	
        qformjQ.each(response.order_items,function(index,item) {
           
          	var row = qformjQ('<tr class="multicart" id="prditem-'+item.prd_id+'">');
            row.append(qformjQ('<td class="pro-title">').html('<p><a href="javascript:void(0)" class="var_title_'+item.prd_first_variant_id+'">'+item.prd_title+'</a>&nbsp;&nbsp;<button type="button" class="descBtn" data-toggle="tooltip" data-placement="left" title="" data-productid="'+item.prd_id+'"> <span class="tooltip">Description</span> </button></p>'));
 			row.append(qformjQ('<td>').html('<img src="'+item.prd_img+'" alt="'+item.prd_title+'">')); 
            row.append(qformjQ('<td>').html('<p><span>'+item.prd_price+'</span></p>')); 
          	
          	// Brand / SKU
           	var item_brand = "Brand: "+item.prd_brand;
            
            if(item.prd_sku != "") {
            var item_sku = "Product SKU: "+item.prd_sku;
            } else {
            var item_sku = item.prd_sku;
            }
          
          	row.append(qformjQ('<td>').html('<p>'+item_brand+'</p><p>'+item_sku+'</p>'));
            //row.append(qformjQ('<td>').html('<p>'+item_sku+'</p>')); 
	
            if(item.prd_soldout == "yes") {
             
            row.append(qformjQ('<td>').html('')); 
           	row.append(qformjQ('<td>').html('<span class="label soldout">Sold Out</span>'));
            qformjQ('#item_results').append(row);  
            
             
           } else {
             
             if(item.prd_variants.length > 1) {
               
                row.append(qformjQ('<td>').html(""));
               	row.append(qformjQ('<td>').html('<div class="qty-form"><input data-variantproid="variantof-'+item.prd_id+'" type="button" value="Show Options" name="selectVariant" class="btn showhidevariant"/></div>'));
               	qformjQ('#item_results').append(row);  
               
                var dynamic_columns = "";
               
                if(item.option1 != "") {
                  dynamic_columns = "<th>"+item.option1+"</th>";
                }
               
               	if(item.option2 != "") {
                  dynamic_columns+= "<th>"+item.option2+"</th>";
                }
               
                if(item.option3 != "") {
                  dynamic_columns+= "<th>"+item.option3+"</th>";
                }
               
               	var variant_row = qformjQ('<tr style="display:none;" class="multicart variantof-'+item.prd_id+'">');
  				variant_row.append(qformjQ('<td colspan="6">').html('<table class="prd_variants_'+item.prd_id+'"><thead><tr class="var_header">'+dynamic_columns+'<th>Product Image</th><th>Price</th><th>Brand/SKU</th><th>Quantity</th><th></th></tr></thead><tbody>'));
                variant_row.append(qformjQ('</td>').html('</tbody></table>'));
               	qformjQ('#item_results').append(variant_row); 
              
            	qformjQ.each(item.prd_variants,function(vrnt_index,vrnt_item) {
               	
                	var multtbl = qformjQ('#item_results .prd_variants_'+item.prd_id+' tbody');
               
                 	multtbl.append(qformjQ('<tr class="multicart varitem_'+vrnt_item.vrnt_id+'">')); 
                  
                  	var var_row = qformjQ('#item_results .prd_variants_'+item.prd_id+' tbody').find('tr.varitem_'+vrnt_item.vrnt_id);
                    if(vrnt_item.vrnt_option1 != "") {
                    var_row.append(qformjQ('<td>').html('<p>'+vrnt_item.vrnt_option1+'</p>'));
                    }
                  
                   	if(vrnt_item.vrnt_option2 != "") {
                    var_row.append(qformjQ('<td>').html('<p>'+vrnt_item.vrnt_option2+'</p>'));
                    }
                  
                    if(vrnt_item.vrnt_option3 != "") {
                    var_row.append(qformjQ('<td>').html('<p>'+vrnt_item.vrnt_option3+'</p>'));
                    }
                  
                  	/*var_row.append(qformjQ('<td>').html('<p><span class="var_title_'+vrnt_item.vrnt_id+'" style="display:none;">'+vrnt_item.vrnt_title+'</span><img src="'+vrnt_item.vrnt_img+'" height="150px" width="150px" style="max-width:150px;max-height:150px;"></p>'));*/
                    /*var_row.append(qformjQ('<td>').html('<p><span class="var_title_'+vrnt_item.vrnt_id+'" style="display:none;">'+vrnt_item.vrnt_title+'</span><img src="'+vrnt_item.vrnt_img+'" width="200px" style="max-width:200px;"></p>'));
					*/
					
					var_row.append(qformjQ('<td>').html('<p><span class="var_title_'+vrnt_item.vrnt_id+'" style="display:none;">'+vrnt_item.vrnt_title+'</span><img src="'+vrnt_item.vrnt_img+'"></p>'));
					
					
                	var_row.append(qformjQ('<td>').html('<p><span><b> '+vrnt_item.vrnt_price+'</b></span></p>'));
                    
                  	//Brand / SKU
                    var brand_html = "Brand: "+item.prd_brand;
                   
                  	if(vrnt_item.vrnt_sku != "") {
                       var sku_html = "Product SKU: "+vrnt_item.vrnt_sku;
                    } else {
                      var sku_html = vrnt_item.vrnt_sku;
                    }
                  
                  	var_row.append(qformjQ('<td>').html('<p>'+brand_html+'</p><p>'+sku_html+'</p>'));
                    
                  	if(vrnt_item.vrnts_sold_out == "yes") {
                        
                      	var_row.append(qformjQ('<td>').html(""));
                    	var_row.append(qformjQ('<td>').html('<span class="label soldout">Sold Out</span>'));
                      
                    } else {
                      	if(vrnt_item.variant_max != "") {
                          //var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+vrnt_item.vrnt_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+vrnt_item.vrnt_id+'" class="list-product-qty currqty_'+vrnt_item.vrnt_id+'" type="'+input_type+'" size="4" value="0" name="updates[]" max="'+vrnt_item.variant_max+'"><input style="cursor:pointer;" id="qtyplus-'+vrnt_item.vrnt_id+'" class="qtyplus" type="button" value="+"><p>In Stock: '+vrnt_item.variant_max+'</p></div>';
                          var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+vrnt_item.vrnt_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+vrnt_item.vrnt_id+'" class="list-product-qty currqty_'+vrnt_item.vrnt_id+'" type="'+input_type+'" size="4" value="0" name="updates[]" max="'+vrnt_item.variant_max+'"><input style="cursor:pointer;" id="qtyplus-'+vrnt_item.vrnt_id+'" class="qtyplus" type="button" value="+"></div>';
                      	}else {
                      	 	var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+vrnt_item.vrnt_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+vrnt_item.vrnt_id+'" class="list-product-qty currqty_'+vrnt_item.vrnt_id+'" type="'+input_type+'" size="4" value="0" name="updates[]" max="'+vrnt_item.variant_max+'"><input style="cursor:pointer;" id="qtyplus-'+vrnt_item.vrnt_id+'" class="qtyplus" type="button" value="+"></div>';
                        }	
                      
                        var_row.append(qformjQ('<td>').html(qty_html));
                      
                  		var addtocart_html = '<div class="qty-form"><form method="post" action="/cart/add" class="AddToCart"><input type="hidden" name="id" value="'+vrnt_item.vrnt_id+'" /><input type="button" value="Add to Cart" id="'+vrnt_item.vrnt_id+'" class="btn singleCart" /></form></div>';
						var_row.append(qformjQ('<td>').html(addtocart_html));
                    } 
                });
               
             } else {
               
               if(item.prd_max != "") {  
                 	//var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+item.prd_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+item.prd_first_variant_id+'" class="list-product-qty currqty_'+item.prd_first_variant_id+'" type="'+input_type+'" size="4" value="0" name="updates[]" max="'+item.prd_max+'"><input style="cursor:pointer;" id="qtyplus-'+item.prd_id+'" class="qtyplus" type="button" value="+"><p>In Stock: '+item.prd_max+'</p></div>';
                 	var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+item.prd_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+item.prd_first_variant_id+'" class="list-product-qty currqty_'+item.prd_first_variant_id+'" type="'+input_type+'" size="4" value="0" name="updates[]" max="'+item.prd_max+'"><input style="cursor:pointer;" id="qtyplus-'+item.prd_id+'" class="qtyplus" type="button" value="+"></div>';
               } else {
                 	var qty_html = '<div class="qty-box clearfix"><input style="cursor:pointer;" id="qtyminus-'+item.prd_id+'" class="qtyminus" type="button" value="-"><input id="updates_'+item.prd_first_variant_id+'" class="list-product-qty currqty_'+item.prd_first_variant_id+'" type="'+input_type+'" size="4" value="0" name="updates[]" max="'+item.prd_max+'"><input style="cursor:pointer;" id="qtyplus-'+item.prd_id+'" class="qtyplus" type="button" value="+"></div>';
               }
                   
               row.append(qformjQ('<td>').html(qty_html));
                  
               var addtocart_html = '<div class="qty-form"><form method="post" action="/cart/add" class="AddToCart"><input type="hidden" name="id" value="'+item.prd_first_variant_id+'"><input type="button" value="Add to Cart" id="'+item.prd_first_variant_id+'" class="btn singleCart" /></form></div>';
			   row.append(qformjQ('<td>').html(addtocart_html));
               
               qformjQ('#item_results').append(row);  
             }
           }
          
           //Append Product Description in a Modal
           var desc_content = qformjQ.parseJSON(item.prd_desc); 
          	
           qformjQ('#orderformpage .discription_div').append('<div id="descModal-'+item.prd_id+'" class="desc_modal" data-productid="'+item.prd_id+'"><div class="desc-modal-content"><div class="modal-header"><button type="button" class="desc-close" data-productid="'+item.prd_id+'" title="Close">&times;</button><h2>'+item.prd_title+'</h2></div><div class="modal-body"><div class="order-desc"><span class="prd-image"><img src="'+item.prd_img+'" alt="'+item.prd_title+'"></span> '+desc_content+'</div></div></div></div>');
        });
  }
  
  //Send AJAX Request
  function get_orderitems(ajax_url,pg_no) 
  { 
    
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function() {
    if(httpRequest.readyState === XMLHttpRequest.DONE) {
      if(httpRequest.status === 200) {
        qformjQ(".orderform-loader").css("display","none");
   
        var response = qformjQ.parseJSON(httpRequest.responseText);
       
        print_html(response); 
      }
    }
   };
    
   qformjQ(".orderform-loader").css("display","inline");
   httpRequest.open('GET',ajax_url, true);
   httpRequest.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
   httpRequest.send();
 }
  
 //Onpageload - Get all products
 get_orderitems(ajax_url,pg_no);
  
  
 //Get Next page items on paging link clicked
 qformjQ(document).on("click",".orderitems_paging button.next_paging", function() {
   var curr_pageno = qformjQ(".orderitems_paging .current_page").data("currpage");
   var next_pageno = parseInt(curr_pageno)+1;
   var chosen_coll = qformjQ("#choose_coll option:selected").val();
   var order_srch_term = qformjQ.trim(qformjQ("input#search_ord_item_term").val());
   var sort_by = qformjQ("#sort_by option:selected").val();
    
   if(order_srch_term != "") {
      qformjQ('#sort_by_container').hide();
      var ajax_url = '/search?q='+order_srch_term+'*&type=product&view=get-orderitems&page='+next_pageno;
      ajax_url = decodeURIComponent(ajax_url);
   
   } else {
      qformjQ('#sort_by_container').show();
      var ajax_url = '/collections/'+chosen_coll+'?page='+next_pageno+'&view=get-orderitems&sort_by='+sort_by;
   }
    
   get_orderitems(ajax_url,next_pageno); 
 });
  
  
 //Get Previous page items on paging link clicked
 qformjQ(document).on("click",".orderitems_paging button.prev_paging", function() {
   var curr_pageno = qformjQ(".orderitems_paging .current_page").data("currpage");
   var prev_pageno = parseInt(curr_pageno)-1;
   var chosen_coll = qformjQ("#choose_coll option:selected").val();
   var ajax_url = '/collections/'+chosen_coll+'?page='+prev_pageno+'&view=get-orderitems';
   var order_srch_term = qformjQ.trim(qformjQ("input#search_ord_item_term").val());
   var sort_by = qformjQ("#sort_by option:selected").val();
   
   if(order_srch_term != "") {
   qformjQ('#sort_by_container').hide();
   var ajax_url = '/search?q='+order_srch_term+'*&type=product&view=get-orderitems&page='+prev_pageno;
   ajax_url = decodeURIComponent(ajax_url);
   } else {
   qformjQ('#sort_by_container').show();
   var ajax_url = '/collections/'+chosen_coll+'?page='+prev_pageno+'&view=get-orderitems&sort_by='+sort_by;
   }
 
    get_orderitems(ajax_url,prev_pageno); 
 });
  
  
 //Onchange collection dropdown - Get Produts of that collection
 qformjQ("#choose_coll").on("change",function() {
   	var chosen_coll = qformjQ("#choose_coll option:selected").val();
    var sort_by = qformjQ("#sort_by option:selected").val();
    var ajax_url = '/collections/'+chosen_coll+'?page='+pg_no+'&view=get-orderitems&sort_by='+sort_by;
   	
    qformjQ("#search_ord_item_term").val("");  //Reset Search Term
    qformjQ('#sort_by_container').show();
   
    get_orderitems(ajax_url,pg_no);
 });
 
  
 //Onkeyup Search
 qformjQ("input#search_ord_item_term").keyup(function(event) {
   	var order_srch_term = qformjQ.trim(qformjQ(this).val());
   	var ajax_url = '/search?q='+order_srch_term+'*&type=product&view=get-orderitems&page=1';
    ajax_url = decodeURIComponent(ajax_url);
   
    qformjQ('#choose_coll').val("all"); //Reset coll dropdown to all categories
    
   	if(order_srch_term != "") {
      qformjQ('#sort_by_container').hide();
    } else {
      qformjQ('#sort_by_container').show();
    }
    get_orderitems(ajax_url,pg_no);
  });
  
  //Prevent Form submission on Enter key press
  qformjQ("input#search_ord_item_term").keypress(function(event) {
     if(event.keyCode == 13) {
      	event.preventDefault();
      	return !1;
     }
  });
  
  //Sorting Collection Products by sort order
  qformjQ("#sort_by").on("change",function() {
   	var sort_by = qformjQ("#sort_by option:selected").val();
    var chosen_coll = qformjQ("#choose_coll option:selected").val();
    var pg_no = qformjQ('.orderitems_paging .current_page').data("currpage"); 
    var ajax_url = '/collections/'+chosen_coll+'?page='+pg_no+'&view=get-orderitems&sort_by='+sort_by;
    get_orderitems(ajax_url,pg_no);
 });
  
  //When the user clicks the button, open the modal 
  qformjQ(document).on("click",'.descBtn',function() {
    var desc_pr_id = qformjQ(this).data("productid");
    var modal_id = "descModal-"+desc_pr_id;
  	qformjQ('#'+modal_id).css('display','block');
 });

};

//Multiple Add To Cart
quicksingleorderform.multiAddToCart = (function($){
 
  function init() {
  loadCartPopup(),closePopups(),multiCartClick(),singleCartClick(),listQty(),incDecQty(),showHideOption(),current_item_list;
  }
  
  function loadCartPopup() {
    qformjQ(document).on('click','.cart_anchor',function(e){
   
    e.preventDefault();
   
   	showCartList();
    });
  }
  
  function closePopups() {
    
  qformjQ(document).on("click",'.desc-close',function() {
    var desc_pr_id = qformjQ(this).data("productid");
    var modal_id = "descModal-"+desc_pr_id;
  	qformjQ('#'+modal_id).css('display','none');
  });
    
  qformjQ(document).on("click",'.cart_close,.continue_btn',function() {
  	qformjQ('.quick-order-cartlist').css('display','none');
  });
  
 
  qformjQ(document).bind("click touchend",function(e) {
	var qformjQtarget = e.target; 

   	if(qformjQ('.desc_modal').is(qformjQtarget)) {    
     qformjQ('.desc_modal').css('display','none');
	}
    
    if(qformjQ('.quick-order-cartlist').is(qformjQtarget)) {    
     qformjQ('.quick-order-cartlist').css('display','none');
	}
  });
    
  }
  
  function pushitems(el,product_id) {
      var currentQty = parseInt(qformjQ(el).val()) || 0;
      current_item_list.items = qformjQ.grep(current_item_list.items, function(e){ 
    	if(e.product_id == product_id) {
       		return false;
     	} else {
       		return true;
        }
      });      	
      current_item_list.items.push({'product_id': product_id,'qty': currentQty});
  }
  
  function multiCartClick() { 
    qformjQ(document).on('click','.current_list-add-to-cart',function(){
    	current_item_list.addItems();
    });
  }
  
  function singleCartClick() {
    qformjQ(document).on('click','.singleCart',function(i){
      
      i.preventDefault();
      
      var att = qformjQ(this).attr("id"),
      qty= qformjQ(".currqty_"+att).val(); 
             	  
      if(qty == 0 || !qformjQ.isNumeric(qty)) { 
      	alert("Sorry! No Items added to Cart, Please enter Qty."); 
        qformjQ(".currqty_"+att).val(0);      
      } 
      else {
      	addinToCart(att,qty); 
      }
    });
  }
  
  function getTotalCount() {
    
    qformjQ.getJSON('/cart.js').done(function(cart) {
      
    	if(cart.item_count > 1) { 
   			qformjQ('#orderformpage #ordercartDiv').html(cart.item_count + ' Items'); 
         }
         else {
         	qformjQ('#orderformpage #ordercartDiv').html(cart.item_count + ' Item'); 
         }
    });
  }
  
  function flyToElement(flyer, flyingTo) {
    var qformjQfunc = qformjQ(this);
    var divider = 2;
    var flyerClone = qformjQ(flyer).clone();
    qformjQ(flyerClone).css({ position: 'absolute', top: qformjQ(flyer).offset().top + "px", left: qformjQ(flyer).offset().left + "px", opacity: 1, 'z-index': 1000 });
    qformjQ('body').append(qformjQ(flyerClone));
    var gotoX = qformjQ(flyingTo).offset().left + (qformjQ(flyingTo).width() / 2) - (qformjQ(flyer).width() / divider) / 2;
    var gotoY = qformjQ(flyingTo).offset().top + (qformjQ(flyingTo).height() / 2) - (qformjQ(flyer).height() / divider) /2;
   
    if(qformjQ('#admin_bar_iframe').width() > 100) {
      gotoY = parseFloat(gotoY)-38;
    } else {
      gotoY = parseFloat(gotoY);
    }
    
    qformjQ(flyerClone).animate({
            opacity: 0.4,
            left: gotoX,
            top: gotoY,
            width: qformjQ(flyer).width() / divider,
            height: qformjQ(flyer).height() / divider
        }, 700,
        function() {
            qformjQ(flyingTo).fadeOut('fast', function() {
                qformjQ(flyingTo).fadeIn('fast', function() {
                    qformjQ(flyerClone).fadeOut('fast', function() {
                        qformjQ(flyerClone).remove();
                    });
                });
            });
        });
	} 
  
  
   function addinToCart(att,qty) {
 
    qty = parseInt(qty);
    var post_data = { id: att, quantity: qty }
    
    qformjQ("#orderformpage .qty-form .AddToCart").find("#"+att).val('Adding....');
     
    qformjQ.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: post_data,
        success: function(itemData) {

            getTotalCount();

			var cart = qformjQ('#ordercartDiv');
            var imgtodrag = qformjQ("#orderformpage .qty-form .AddToCart").find("#"+att).closest('tr.multicart').find("img").eq(0);
         
            flyToElement(qformjQ(imgtodrag), qformjQ('#ordercartDiv'));

            window.setTimeout(function() { qformjQ("#orderformpage .qty-form .AddToCart").find("#"+att).val('Thank You'); }, 400);
            window.setTimeout(function() { qformjQ("#orderformpage .qty-form .AddToCart").find("#"+att).val('Add More...'); }, 1000);
        },
        error: function(XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');

            response = response.description;
            qformjQ("#orderformpage .qty-form .AddToCart").find("#"+att).val('Add to Cart');
            alert(response);
        }
    });		 
  }
  
  var current_item_list = {
    items: [],
    addItems: function() {
      
      if(this.items.length > 0) {
      if(typeof this.items != undefined) {
        
        Shopify.queue = [];
        
        qformjQ.each(this.items, function(k,arr){
	    	Shopify.queue.push({
	      	variantId: arr['product_id'],
          	quantity: arr['qty']
	    	});
        });
        
         Shopify.moveAlong = function() {
	  	 
         //If we still have requests in the queue, let's process the next one.
	 	 if(Shopify.queue.length) {
	    	var request = Shopify.queue.shift();
	    	var data = 'id='+ request.variantId + '&quantity='+request.quantity;
	    	qformjQ.ajax({
	      		type: 'POST',
              	url: '/cart/add.js',
	      		dataType: 'json',
	      		data: data,
	      		success: function(res){
	        	Shopify.moveAlong();
	     		},
             	error: function(){
	     			//if it's not last one Move Along else update the cart number with the current quantity
		  			if (Shopify.queue.length){
		    			Shopify.moveAlong();
		  			} else {
		    			getTotalCount(); 
		  			}
	      		}
           });
      	} else{
          getTotalCount(); 
          showCartList();
      	} 
    	};
        
    	Shopify.moveAlong();
        
        setTimeout(function(){  reset_current_list();  }, 1000);
    	
      } 
    } else {
    alert("Please fill Quantity field.");
  	}
    },
  }
  
  function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  
  function listQty(){
    qformjQ(document).on('keypress','.list-product-qty',function(evt) {
       var isno = isNumber(evt);
       if(!isno) {
         return false;
       }
    });
   
    qformjQ(document).on('keyup','.list-product-qty',function() {
         	var ele_id = qformjQ(this).attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var qformjQqtyInput = qformjQ("#"+ele_id);
            var currentVal = parseInt(qformjQqtyInput.val()) || 0;
  		    var qtyMax = parseInt(qformjQqtyInput.attr('max'));
            
  			if(currentVal > qtyMax) {
          		alert("We have maximum "+qtyMax+" items in stock.");
   		 		qformjQqtyInput.val(qtyMax);	
  			} 
         
         	if(currentVal >= 1) {
  				pushitems(qformjQqtyInput,product_id);
            } else {
            	current_list_remove(product_id);
         	}
	 });
  
  }
  
  function incDecQty(){
        // Increment qty function 
       qformjQ(document).on('click','.qtyplus',function() {     
          
          	var ele_id = qformjQ(this).siblings(".list-product-qty").attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var qformjQqtyInput = qformjQ("#"+ele_id);
  			var currentVal = parseInt(qformjQqtyInput.val());
  			var qtyMax = parseInt(qformjQqtyInput.attr('max'));
          	
          	if(currentVal >= qtyMax) {
              	alert("We have maximum "+qtyMax+" items in stock.");
   		 		qformjQqtyInput.val(qtyMax);
              
  			} else {
  				qformjQqtyInput.val(currentVal+1);	
          	}
          
          	pushitems(qformjQqtyInput,product_id);
		});
  
  
  		// Decrement qty function
		qformjQ(document).on('click','.qtyminus',function() {    
          
          	var ele_id = qformjQ(this).siblings(".list-product-qty").attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var qformjQqtyInput = qformjQ("#"+ele_id);
  			var currentVal = parseInt(qformjQqtyInput.val());
          
    		if(currentVal >= 1) {
      			qformjQqtyInput.val(currentVal - 1);
           		pushitems(qformjQqtyInput,product_id);
   		 	} else {
              	current_list_remove(product_id);
            }
	    });
   }
  
  function showHideOption(){
     	// Show / hide variant options
  		qformjQ(document).on('click','.showhidevariant',function() { 
          
           	var varintof_productid = qformjQ(this).data("variantproid");
           	qformjQ("."+varintof_productid).toggle();
           		qformjQ(this).val(function(i,val){
            	return val === "Show Options" ? "Hide Options" : "Show Options";
      		});
        });
  }
  
  function current_list_remove(remove_prdid)
  {
     
    	current_item_list.items = qformjQ.grep(current_item_list.items, function(e){ 
  
    		if(e.product_id == remove_prdid) {
       			return false;
     		} else {
       			return true;
    		}
   		});   
     	
     	return true;
   }
  
   function showCartList() 
   {
     qformjQ(".orderform-loader").show();
     
     qformjQ.getJSON('/cart.js').done(function(cart) {
        
       	console.log(cart);
      
       	qformjQ(".orderform-loader").hide();
    	qformjQ(".quick-order-cartlist").css('display','block');
       
       	//Update Header Cart Count
      	if(qformjQ('#CartCount').length>0) {
          qformjQ('#CartCount').html(cart.item_count); 
        } else {
           qformjQ(".headerCart").find(".content-text").prepend('<div id="CartCount" class="site-header__cart-count"><span>'+cart.item_count+'</span><span class="icon__fallback-text medium-up--hide">items</span></div>');
        } 
       
        qformjQ(".modal-header").find("#total_cnt").html("Your Cart has "+cart.item_count+" Items");
       	
       	var cart_row = "";
         var pro_img = "";
       	qformjQ('#quick-minicartlist').empty();
       	qformjQ(".quick-order-cartlist .modal-body").show();
        qformjQ(".quick-order-cartlist .modal-footer").show();
       
        if(cart.item_count > 0) {
       	
          	qformjQ.each(cart.items, function(item_index,item_arr) {
          	cart_row = qformjQ('<tr class="quick-cartitem" id="prditem-'+item_arr.id+'">');
              
			if(item_arr.image != null) {
              pro_img = item_arr.image;
              
             //For smaller size image to load - 786
             var img_without_extension = pro_img.substr(0, pro_img.lastIndexOf('.')) || pro_img;
             var img_ext = pro_img.split('.').pop();
             img_ext = img_ext.substring(0, img_ext.indexOf('?v'));
             var small_img = img_without_extension+"_small."+img_ext;
			 pro_img = small_img;
			 
			 //Ended Here - 786
            } else {
             pro_img = window.order_no_image;
            }
			 //Ended Here - 786
				
            cart_row.append(qformjQ('<td>').html('<a href="'+item_arr.url+'"><span class="pro_img"><img src="'+pro_img+'" /></span><span class="pro_title">'+item_arr.title+'</span></a>'));  
           	//cart_row.append(qformjQ('<td>').html('<a href="'+item_arr.url+'">'+item_arr.title+'</a>'));
            cart_row.append(qformjQ('<td>').html('<p>'+item_arr.quantity+'</p>'));
          	cart_row.append(qformjQ('<td>').html('<span>'+Shopify.formatMoney(item_arr.price, window.quick_order_money_format)+'</span>'));
 			
          	qformjQ('#quick-minicartlist').append(cart_row);  
        	
            });
      
        	qformjQ(".modal-footer").find(".sub_total_amount").html('<span>'+Shopify.formatMoney(cart.total_price, window.quick_order_money_format)+'</span>');
       
        } else {
          qformjQ(".quick-order-cartlist .modal-body").hide();
          qformjQ(".quick-order-cartlist .modal-footer").hide();
        }
     });
   }
  
   function reset_current_list() 
   {
       current_item_list.items = [];
       qformjQ('.list-product-qty').val(0).trigger("change");	
       qformjQ("#orderformpage .qty-form .singleCart").val("Add to Cart");
   }
  
   return {
   		init: init,
    	reset_current_list:reset_current_list,
    	current_item_list:current_item_list,
   }
}(jQuery)); 

//Call Quick Single Order Form APP JS             
qformjQ(document).ready(function() {
	qformjQ(quicksingleorderform.init);
});
